import { useContext } from "react";
import { PresetsContext } from "./Provider";

export default function usePresetsContext() {
  const context = useContext(PresetsContext);

  return context;
}
